const ITEMS = [
  "Eco-Conscious Products",
  "Harlow & Essex Coverage",
  "White-Glove Audit",
  "Insured & Vetted Cleaners",
  "Deposit-Back Tenancy Cleans",
  "The Sparkle Standard",
];

export default function Marquee() {
  const strip = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[#E5DEC3] bg-[#F3EFEA] py-6"
    >
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {strip.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif text-2xl font-light italic tracking-wide text-[#1B523F]/70 lg:text-3xl">
              {item}
            </span>
            <span className="mx-10 h-1.5 w-1.5 rounded-full bg-[#D4AF37]" />
          </span>
        ))}
      </div>
    </div>
  );
}
